import { SVGProps } from 'react';

const CameraIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#E4E4E7"
        d="M18 6.75v10.5a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V6.75A1.5 1.5 0 0 1 3 5.25h13.5a1.5 1.5 0 0 1 1.5 1.5Zm5.438.023a.772.772 0 0 0-.622.115l-3.15 2.099a.375.375 0 0 0-.166.312v5.402a.376.376 0 0 0 .167.312l3.167 2.111a.751.751 0 0 0 .804.018.781.781 0 0 0 .362-.672V7.5a.75.75 0 0 0-.563-.727Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default CameraIcon;
